import { clone, findIndex, forEach } from 'lodash-es';
import Moment from 'moment';
import { Subject } from 'rxjs';
import { Validator } from 'vee-validate';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import googleAutoComplete from '../../services/googleAPI/autoComplete';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import util from '../../shared/util';
import tlp from './addPayment.vue';
@Component({
    name: 'AddPayment',
    mixins: [tlp],
    components: {
        Datepicker,
        UinsDefaultSelect,
    },
})
export default class AddPayment extends Vue {
    @Inject() $validator: Validator;

    @Prop({
        default: '',
    })
    quoteId: any;

    @Prop({
        default: '',
    })
    orderId: any;

    @Prop({
        default: '',
    })
    editPayment: any;

    @Prop({
        default: '',
    })
    billToId: any;

    @Prop({
        default: '',
    })
    applyAmount: string;

    @Prop({
        default: [],
    })
    invoiceIdAry: Array<any>;

    showErrTip: boolean = false;
    errorText: String = '';
    tipType: string = '';
    prQuoteId: string = '';
    payMethodList: any = [];
    isNext: Boolean = false;

    visa: Boolean = false;
    master: Boolean = false;
    discover: Boolean = false;
    american: Boolean = false;
    paypal: Boolean = false;
    isHasACH: Boolean = true;
    isSameAsAddress: Boolean = false;
    prShipping: any = {};
    billingAddress: any = {
        shipper_zipcode: '',
        shipper_city: '',
        shipper_state: '',
    };
    fnCompareBillingAddress: Subject<void> = new Subject();
    truckloadForm: any = {};
    cloneBillinglocation: any = {};
    payMethod: any = '';
    achAccountType: any = ['BUSINESS', 'CHECKING'];
    addPayType: string = 'Credit Card';
    achCardholder: string = '';
    defaultMethod: Boolean = false;
    isDdisabledCardNumber: Boolean = false;
    reditCardName: string = '';
    reditCardNumber: any = '';
    reditCardExp: string = '';
    reditCardCcv: any = '';
    reditCardZip: any = '';
    reditCardCountry: any = 'US';
    paypalEmail: string = '';
    location_zip: any = '';
    location_state: any = '';
    location_city: any = '';
    location_street: any = '';
    location_street2: any = '';
    country_region: any = '';
    achAccount: any = '';
    achRouting: any = '';
    achType: any = '';
    carErr: any = '';
    mounted() {
        if (this.editPayment) this.fillCart();
        this.fnCompareBillingAddress
            .debounceTime(800)
            .subscribe(this.compareBillingAddress, err => {});
    }

    fillCart() {
        this.reditCardExp = this.editPayment.exp_date
            .split('/')
            .reverse()
            .map((d: any) => (/^\d$/.test(d) ? '0' + d : d))
            .join('-');
        this.reditCardName = this.editPayment.name_on_card;
        this.reditCardCountry = this.editPayment.text_1;
        this.reditCardName = this.editPayment.text_3;
        this.reditCardZip = this.editPayment.text_7;
        this.reditCardName = this.editPayment.text_8;
        this.reditCardCcv = this.editPayment.text_9;
        const noLine = this.editPayment.account.replace(/\s/g, '');
        this.reditCardNumber = noLine
            .replace(/\D+/g, '')
            .replace(/(\d{4})/g, '$1 ')
            .replace(/\s$/, '');
        this.location_street = this.editPayment.location_street;
        this.location_street2 = this.editPayment.location_street2;
        this.reditCardCountry = this.editPayment.reditCardCountry;
        this.location_city = this.editPayment.location_city;
        this.location_state = this.editPayment.location_state;
    }

    fillPaymentMethod(payments: any) {
        /*this.editPayments*/
    }

    compareBillingAddress() {
        if (this.quoteId) {
            localStorage.removeItem('pickupAddress');
            localStorage.setItem(
                'pickupAddress',
                JSON.stringify({
                    quoteId: this.quoteId,
                    location_street: this.location_street,
                })
            );
        }

        if (
            this.cloneBillinglocation.pickup_location_zip === this.reditCardZip &&
            this.cloneBillinglocation.pickup_location_state === this.location_state &&
            this.cloneBillinglocation.pickup_location_city === this.location_city &&
            this.cloneBillinglocation.pickup_location_street === this.location_street
        ) {
            this.isSameAsAddress = true;
        } else {
            this.isSameAsAddress = false;
        }
    }

    _zipAutoCompletes() {
        this.zipAutoComplete({
            id: 'autoComplete01',
            value: this.billingAddress,
            key1: 'shipper_zipcode',
            key2: 'shipper_city',
            key3: 'shipper_state',
        });
    }

    async zipAutoComplete(moudel: any) {
        if (document.getElementById(moudel.id) == null) {
            return;
        }
        let autoComplete = new googleAutoComplete(moudel.id);
        autoComplete.setShortStateName();
        while (true) {
            let result: any = await autoComplete.searchResult();
            this.$set(moudel.value, moudel.key1, result.postal_code);
            this.$set(moudel.value, moudel.key2, result.city);
            this.$set(moudel.value, moudel.key3, result.state);
        }
    }

    onSameAsAddress() {
        this.reditCardZip = '';
        this.location_state = '';
        this.location_city = '';
        this.location_street = '';
        this.location_street2 = '';
        this.isSameAsAddress = !this.isSameAsAddress;
        if (this.isSameAsAddress) {
            let parames = {
                UserID: localStorage.getItem('UserID'),
                UserToken: localStorage.getItem('UserToken'),
            };
            if (this.quoteId) {
                parames['quote_id'] = this.quoteId;
            } else if (this.orderId) {
                parames['order_id'] = this.orderId;
            }
            tmsServiceBackend.post(`/order/shipper_address`, parames).then(
                (res: any) => {
                    let pickupLocation = res.data.data ? res.data.data : {};
                    let prpickupLocation = clone(pickupLocation);
                    if (this.quoteId) {
                        let localStoragPickupAddress: any = localStorageUtil.getItemFromStorage(
                            'pickupAddress'
                        );
                        if (this.quoteId == localStoragPickupAddress.quoteId) {
                            prpickupLocation.pickup_location_street =
                                localStoragPickupAddress.location_street;
                        }
                    }
                    this.reditCardZip = prpickupLocation.pickup_location_zip;
                    this.location_state = prpickupLocation.pickup_location_state;
                    this.location_city = prpickupLocation.pickup_location_city;
                    this.location_street = prpickupLocation.pickup_location_street;
                    this.location_street2 = prpickupLocation.pickup_location_street2;
                    this.cloneBillinglocation = clone(prpickupLocation);
                },
                (err: any) => {
                    console.log(err);
                }
            );
        }
    }

    getpayMethodPermission() {
        tmsServiceBackend.get(`/payment/method/permission`).then(
            (res: any) => {
                let permission = res.data.data;
                if (permission.ACH && permission.ACH == 'Y') this.isHasACH = false;
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    getpayMethodList() {
        tmsServiceBackend
            .post(`/payment/getPaymentMethodList?billto_id=${this.billToId}&create_from=CLIENT`)
            .then(
                (res: any) => {
                    this.payMethodList = res.data.data;
                    forEach(this.payMethodList, (item, index) => {
                        if (item.card_type == 'Mastercard') {
                            this.master = true;
                        }
                        if (item.card_type == 'Visa') {
                            this.visa = true;
                        }
                        if (item.card_type == 'American Express') {
                            this.american = true;
                        }
                        if (item.card_type == 'Discover') {
                            this.discover = true;
                        }
                        if (item.payment_method == 'Paypal') {
                            this.paypal = true;
                        }
                    });
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    setPayMent(type: string) {
        this.addPayType = type;
    }

    closeModal() {
        this.$emit('closeModal', true);
    }

    addPayPal(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                this.isNext = true;
                let prReditCardExps = Moment(this.reditCardExp).format('MM/yyyy');
                let parames = {
                    account: this.reditCardNumber,
                    expdate: prReditCardExps,
                    name_on_card: this.reditCardName,
                    zip: this.reditCardZip,
                    cv: this.reditCardCcv,
                };
                tmsServiceBackend.post(`/payment/method/verify_card`, parames).then(
                    (res: any) => {
                        if (res.data.status && res.data.status == 1) {
                            this.addCard(prReditCardExps);
                            return;
                        }
                        if (res.data.error) {
                            this.carErr = res.data.error;
                            this.isNext = false;
                        }
                    },
                    (err: any) => {
                        console.log(err);
                        this.isNext = false;
                    }
                );
            }
        });
    }

    addReditCard(card: any) {
        return new Promise((resolve, reject) => {
            tmsServiceBackend
                .post(
                    `/payment/addPaymentMethodCc?
                account=${this.reditCardNumber}&
                exp_date=${Moment(this.reditCardExp).format('MM/yyyy')}&
                name_on_card=${this.reditCardName}&
                cv=${this.reditCardCcv}&
                zip=${this.reditCardZip}&
                bill_to=${this.billToId}&
                location_state=${this.location_state}&
                location_city=${this.location_city}&
                location_street=${this.location_street}&
                location_street2=${this.location_street2}&
                country_region=${this.country_region}&
                is_default_payment=${this.defaultMethod ? '1' : '0'}`
                )
                .then(
                    (res: any) => {
                        resolve(
                            res.data.data && res.data.data.location_cx1_id
                                ? res.data.data.location_cx1_id
                                : ''
                        );
                    },
                    (err: any) => {
                        reject(err);
                        this.isNext = false;
                    }
                );
        });
    }
    async addAchCard(card: any) {
        return new Promise((resolve, reject) => {
            tmsServiceBackend
                .post(
                    `/payment/addPaymentMethodAch?
                account=${this.achAccount}&
                aba_route=${this.achRouting}&
                account_type=${this.achType}&
                name_on_card=${this.achCardholder}&
                bill_to=${this.billToId}&
                zip=${this.reditCardZip}&
                location_state=${this.location_state}&
                location_city=${this.location_city}&
                location_street=${this.location_street}&
                location_street2=${this.location_street2}&
                country_region=${this.country_region}&
                is_default_payment=${this.defaultMethod ? '1' : '0'}`
                )
                .then(
                    (res: any) => {
                        resolve(
                            res.data.data && res.data.data.location_cx1_id
                                ? res.data.data.location_cx1_id
                                : ''
                        );
                    },
                    (err: any) => {
                        reject(err);
                        this.isNext = false;
                    }
                );
        });
    }

    async addCard(prReditCardExps: any) {
        let card: any = {
            zip: this.reditCardZip,
            cv: this.reditCardCcv,
            exp_date: prReditCardExps,
            name_on_card: this.reditCardName,
            text_1: this.reditCardCountry,
            text_2: prReditCardExps,
            text_3: this.reditCardName,
            text_7: this.reditCardZip,
            text_8: this.reditCardName,
            text_9: this.reditCardCcv,
            account: this.reditCardNumber,
            location_street: this.location_street,
            location_street2: this.location_street2,
            reditCardCountry: this.reditCardCountry,
            location_city: this.location_city,
            location_state: this.location_state,
            form: 'oneTime',
            payment_method: 'CC',
            card_type: 'Visa',
            is_default_payment: '0',
            creation_time: new Date().getTime(),
        };

        if (this.addPayType == 'Credit Card') {
            await this.addReditCard(card).then((res: any) => {
                console.log(res);
                card.paymethod_id = res;
            });
        }
        if (this.addPayType == 'ACH Transfer') {
            await this.addAchCard(card).then((res: any) => {
                card.paymethod_id = res;
            });
        }

        let payMents = util.Base64DncodeForArray(
            localStorageUtil.getItemFromStorage(util.Base64EncodetoString('AddPayMents'))
        );
        if (this.editPayment && this.editPayment.creation_time) {
            let cardNumberIndex = findIndex(payMents, {
                creation_time: this.editPayment.creation_time,
            });
            if (cardNumberIndex > -1) {
                if (payMents.length > 0) {
                    payMents.splice(cardNumberIndex, 1);
                    payMents.splice(cardNumberIndex, 0, card);
                    localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
                    localStorage.setItem(
                        util.Base64EncodetoString('AddPayMents'),
                        JSON.stringify(util.Base64EncodeForArray(payMents))
                    );
                } else {
                    localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
                }
            }
        } else if (payMents && payMents.length > 0) {
            payMents.push(card);
            localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
            localStorage.setItem(
                util.Base64EncodetoString('AddPayMents'),
                JSON.stringify(util.Base64EncodeForArray(payMents))
            );
        } else {
            localStorage.setItem(
                util.Base64EncodetoString('AddPayMents'),
                JSON.stringify(util.Base64EncodeForArray([card]))
            );
        }
        this.$emit('addNewPayment', card);
        this.isNext = false;
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
            this.tipType = '';
        }, 3000);
    }

    formatCardNumber(e: any) {
        const input = e.target;
        const cursorIndex = input.selectionStart;
        const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || [])
            .length;
        const noLine = e.target.value.replace(/\s/g, '');
        const newCardNum = noLine
            .replace(/\D+/g, '')
            .replace(/(\d{4})/g, '$1 ')
            .replace(/\s$/, '');
        const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length;
        const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft;
        this.$nextTick(() => {
            this.reditCardNumber = newCardNum;
            this.$nextTick(() => {
                input.selectionStart = newCursorIndex;
                input.selectionEnd = newCursorIndex;
            });
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/addPayment/index.ts